import i18n from '@/utils/i18n'

export default {
  path: '/user',
  component: () => import(/* webpackChunkName: "about" */ '../views/entry'),
  children: [
    {
      path: '/', // 首页
      name: 'userHome',
      meta: {
        title: i18n.t('index3') // '首页'
      },
      component: () =>
        import(/* webpackChunkName: "about" */ '../views/user/home')
    },
    {
      path: 'transfer', // 转账
      name: 'userTransfer',
      meta: {
        title: i18n.t('index7') // '转账'
      },
      component: () =>
        import(
          /* webpackChunkName: "Withdrawal" */
          '../views/user/transfer'
        )
    },
    {
      path: 'wallet',
      name: 'userWallet',
      meta: {
        title: i18n.t('index8') // 钱包
      },
      component: () => import('../views/user/wallet')
    },
    {
      path: 'mining-rewards', // 每日成长赠金
      name: 'miningRewards',
      meta: {
        title: i18n.t('usermenu2') // '每日成长赠金'
      },
      component: () => import(/* webpackChunkName: "miningRewards" */ '../views/user/miningRewards')
    },
    {
      path: 'forex-bonus', // 风险补偿赠金
      name: 'forexBonus',
      meta: {
        title: i18n.t('usermenu1') // '风险补偿赠金'
      },
      component: () => import(/* webpackChunkName: "forexBonus" */ '../views/user/forexBonus')
    },
    {
      path: 'fund-streams',
      name: 'userFundStreams',
      meta: {
        title: i18n.t('fundstreams1')
      },
      component: () => import(/* webpackChunkName: "fundStreams" */ '../views/user/fundStreams')
    },

    {
      path: 'transfer-record', //  '账户转账记录'
      name: 'userTransferRecord',
      meta: {
        title: i18n.t('usermenu3') // '账户划转记录'
      },
      component: () => import('../views/user/records/transferRecord')
    },
    {
      path: 'agent-transfer', // 代理转账记录
      name: 'userAgentTransfer',
      meta: {
        title: i18n.t('usermenu4') // '账户转账记录'
      },
      component: () => import('../views/user/reportManage/agentTransfer.vue')
    },
    {
      path: 'day-trade', // 日内交易记录
      name: 'userDayTrade',
      meta: {
        title: i18n.t('userstatement92') //  '日内交易记录'
      },
      component: () => import('../views/user/reportManage/dayTrade.vue')
    },
    {
      path: 'finance-transaction', // 融资交易记录
      name: 'userFinanceTransaction',
      meta: {
        title: i18n.t('userstatement118') //   '融资交易记录'
      },
      component: () => import('../views/user/reportManage/financeTransaction.vue')
    },
    {
      path: 'promotion-center',
      name: 'userPromotionCenter',
      meta: {
        title: i18n.t('promotionCenter')
      },
      component: () => import('../views/user/promotionCenter')
    },
    {
      path: 'invitation-detail',
      name: 'userInvitationDetail',
      meta: { title: i18n.t('invitationDetailsV2') },
      component: () => import('../views/user/invitationDetail')
    },
    {
      path: 'commission-details-new',
      name: 'userCommissionDetailsNew',
      meta: { title: i18n.t('commissionDetailsV2') },
      component: () => import('../views/user/commissionDetail')
    },
    {
      path: 'membership-center',
      name: 'userMembershipCenter',
      meta: {
        title: i18n.t('membershipCenter')
      },
      component: () => import('../views/user/membershipCenter')
    },
    {
      path: 'user-info', // 基础信息
      name: 'userInfo',
      meta: {
        title: i18n.t('index20') // '基础信息'
      },
      component: () =>
        import(
          /* webpackChunkName: "UserInfo" */
          '../views/user/userInfo/info.vue'
        )
    },
    {
      path: 'notice', // 基础信息
      name: 'notice',
      meta: {
        title: i18n.t('index35')
      },
      component: () =>
        import(
          /* webpackChunkName: "UserInfo" */
          '../views/public/notice/index.vue'
        )
    }
  ]
}
